import { render, staticRenderFns } from "./w-testimonials.vue?vue&type=template&id=7b8396be"
import script from "./w-testimonials.vue?vue&type=script&lang=js"
export * from "./w-testimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports